module.exports = __webpack_public_path__ + "img/sing-screenshot.ebac30e6.jpg";